import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { ShoppingCart } from "@material-ui/icons";
import { Link, useLocation } from "react-router-dom";

import useStyles from "./Styles";
import logo from "../../assets/commerce.png";

function Navbar({ totalItem }) {
  const classes = useStyles();
  const location = useLocation();

  return (
    <>
      <AppBar position={"fixed"} className={classes.appBar} color={"#6600FF"}>
        <Toolbar>
          <Typography
            component={Link}
            to={"/"}
            variant="h6"
            style={{ color: "#001" }}
            className={classes.title}
          >
            <img
              src={logo}
              alt={"Commerce.js"}
              height="25px"
              className={classes.image}
            />
            Commerce.js
          </Typography>
          <div className={classes.grow} />
          {location.pathname === "/" && (
            <div className={classes.button}>
              <IconButton
                component={Link}
                to={"/cart"}
                aria-label="Show car items"
                color="#6600FF"
              >
                <Badge badgeContent={totalItem} color="secondary">
                  <ShoppingCart />
                </Badge>
              </IconButton>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
}

export default Navbar;
